import { TextButton } from '@wix/design-system'
import React, { FC, memo } from 'react'

import { dataHooks } from './Category.dataHooks'

type SuggestionItemProps = {
  text: string
  index: number
  onClick: (text: string, index: number) => void
}

export const SuggestionItem: FC<SuggestionItemProps> = memo(({ text, index, onClick }) => (
  <TextButton skin="dark" onClick={() => onClick(text, index)} dataHook={dataHooks.suggestion({ index })}>
    {text}
  </TextButton>
))
